module.exports = __webpack_public_path__ + "img/programme2.040af0b3.png";